import React from "react";

import { HistoryForm } from "../components/HistoryForm/HistoryForm";
import { Safearea } from "../components/UI/Safearea/Safearea";
import { Header } from "../components/Layout/Header/Header";

export const HistoryPage = () => {
  return (
    <React.Fragment>
      <Header title="Historico" />
      <Safearea>
        <HistoryForm />
      </Safearea>
    </React.Fragment>
  );
};
